export default __webpack_public_path__ + "static/media/calendar-history.0b6c5356.svg";